exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#free-term-confirmation .note-container[data-v-89080c42]{text-align:right;max-width:1000px;margin:1em auto}#free-term-confirmation .note-container label[for=note][data-v-89080c42]{color:#588fc7;font-weight:700}#free-term-confirmation .note-container #note[data-v-89080c42]{width:calc(100% - 155px)}#free-term-confirmation .note-container .btn-confirm[data-v-89080c42]{margin-top:2em;font-weight:500}#free-term-confirmation .free-term[data-v-89080c42]{margin:auto}#free-term-confirmation #no-reservation-permission[data-v-89080c42]{text-align:center}#free-term-confirmation #no-reservation-permission .warn[data-v-89080c42]{color:#588fc7;font-weight:400}#free-term-confirmation #no-reservation-permission .info[data-v-89080c42]{font-weight:300;font-size:16px;margin-bottom:3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-89080c42&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FreeTermConfirmation.vue
// module id = 156
// module chunks = 0